export default __webpack_public_path__ + "static/media/mat.7911f535.jpg";